import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Stack, Typography } from "@mui/material";
import { FieldValues, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import * as yup from "yup";

import CustomTextField from "../../../../../../../components/molecules/custom-textfield/custom-textfield";
import { useReadProjectActivityAnnotation } from "../../../../../../../hooks/react-query/project/use-read-activity-annotation";
import { createAnnotationActivity } from "../../../../../../../services/activities";
import { ActivityDTO } from "../../types/activityDTO";
import AnnotationCard from "./annotation-card";

const AnnotationSchema = yup.object().shape({
    annotation: yup
        .string()
        .required("Você deve enviar algo no seu comentário"),
});

type TAnnotation = {
    activity: ActivityDTO;
};

export const Annotation = ({ activity }: TAnnotation) => {
    const { control, handleSubmit, reset } = useForm({
        defaultValues: {
            annotation: "",
        },
        resolver: yupResolver(AnnotationSchema),
        mode: "onSubmit",
    });

    const { data, refetch } = useReadProjectActivityAnnotation({
        activityId: activity.id_e,
    });
    const submit = (data: FieldValues) => {
        createAnnotationActivity({
            activityId: activity.id_e,
            params: { text: data.annotation },
        }).then(() => {
            toast.success("Seu comentário foi enviado com sucesso!");
            refetch();
            reset();
        });
    };

    const comments = data?.data ?? [];

    return (
        <Stack
            sx={{
                gap: "1.5rem",
            }}
        >
            <form onSubmit={handleSubmit(submit)}>
                <Stack
                    sx={{
                        mt: "1.5rem",
                        p: "1.5rem",
                        gap: "1.5rem",
                        borderTop: "1px solid  #E0E0E0",
                        borderBottom: "1px solid  #E0E0E0",
                    }}
                >
                    <Typography variant="h5">Anotações</Typography>
                    <CustomTextField
                        control={control}
                        name="annotation"
                        label="Comentário"
                        placeholder="Novo comentário"
                        fullWidth
                    />
                    <Button
                        variant="contained"
                        sx={{
                            width: "4.8125rem",
                        }}
                        type="submit"
                    >
                        SALVAR
                    </Button>
                </Stack>
            </form>
            <Stack
                sx={{
                    gap: "1.5rem",
                    maxHeight: "28.5rem",
                    pt: "1rem",
                    overflowY: "auto",
                }}
            >
                {comments
                    .map((comment) => (
                        <AnnotationCard
                            key={comment.id_e}
                            activityId={activity.id_e}
                            annotationData={comment}
                            refetch={refetch}
                        />
                    ))
                    .reverse()}
            </Stack>
        </Stack>
    );
};
